import { pascalCase } from 'change-case'

import type { ItemListSortInputOption } from './type'

import i18n from '@/lib/i18n'

const optionValue = (field: string, sortDirection: string) => {
  return `${field}${pascalCase(sortDirection)}`
}

export const fields = {
  brandNameAsc: {
    field: 'brandName',
    sortDirection: 'asc',
    label: i18n.t('item.list.sort.brandNameAsc'),
  },
  brandNameDesc: {
    field: 'brandName',
    sortDirection: 'desc',
    label: i18n.t('item.list.sort.brandNameDesc'),
  },
  itemNameAsc: {
    field: 'itemName',
    sortDirection: 'asc',
    label: i18n.t('item.list.sort.itemNameAsc'),
  },
  itemNameDesc: {
    field: 'itemName',
    sortDirection: 'desc',
    label: i18n.t('item.list.sort.itemNameDesc'),
  },
  salonPriceAsc: {
    field: 'salonPrice',
    sortDirection: 'asc',
    label: i18n.t('item.list.sort.salonPriceAsc'),
  },
  salonPriceDesc: {
    field: 'salonPrice',
    sortDirection: 'desc',
    label: i18n.t('item.list.sort.salonPriceDesc'),
  },
  salesStartDateAsc: {
    field: 'salesStartDate',
    sortDirection: 'asc',
    label: i18n.t('item.list.sort.salesStartDateAsc'),
  },
  brandStartDateDesc: {
    field: 'salesStartDate',
    sortDirection: 'desc',
    label: i18n.t('item.list.sort.salesStartDateDesc'),
  },
}

export const options: ItemListSortInputOption[] = [
  {
    label: fields.brandNameAsc.label,
    value: optionValue(
      fields.brandNameAsc.field,
      fields.brandNameAsc.sortDirection
    ),
  },
  {
    label: fields.brandNameDesc.label,
    value: optionValue(
      fields.brandNameDesc.field,
      fields.brandNameDesc.sortDirection
    ),
  },
  {
    label: fields.itemNameAsc.label,
    value: optionValue(
      fields.itemNameAsc.field,
      fields.itemNameAsc.sortDirection
    ),
  },
  {
    label: fields.itemNameDesc.label,
    value: optionValue(
      fields.itemNameDesc.field,
      fields.itemNameDesc.sortDirection
    ),
  },
  {
    label: fields.salonPriceAsc.label,
    value: optionValue(
      fields.salonPriceAsc.field,
      fields.salonPriceAsc.sortDirection
    ),
  },
  {
    label: fields.salonPriceDesc.label,
    value: optionValue(
      fields.salonPriceDesc.field,
      fields.salonPriceDesc.sortDirection
    ),
  },
  {
    label: fields.salesStartDateAsc.label,
    value: optionValue(
      fields.salesStartDateAsc.field,
      fields.salesStartDateAsc.sortDirection
    ),
  },
  {
    label: fields.brandStartDateDesc.label,
    value: optionValue(
      fields.brandStartDateDesc.field,
      fields.brandStartDateDesc.sortDirection
    ),
  },
]
